import React, {Component} from 'react';
import 'semantic-ui-css/semantic.min.css';
import * as api from "../../api";
import SupplierMeterTableHeader from "./supplier-meter-table-header";
import SupplierMeterTableRow from "./supplier-meter-table-row";
import ArrayDataProvider from "../../components/table/data-providers/array-data-provider";
import FilterableDatatable from "../../components/table/filterable-data-table";

export default class SupplierMeterDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dataProvider: new ArrayDataProvider([]),
        }
    }

    componentDidMount = () => {
        this.fetchData();
    }

    fetchData = () => {
        api.getSupplierInvoiceReadings(this.props.supplierInvoiceKey)
            .then(response => this.state.dataProvider.updateDataSource(response));
    }

    render() {
        return (
            <FilterableDatatable dataProvider={this.state.dataProvider} name="supplier-invoice-readings"
                                 refreshDataTrigger={this.state.dataProvider.onDataSourceChanged}
                                 headerComponent={SupplierMeterTableHeader} rowComponent={SupplierMeterTableRow}/>
        );
    }
}